import PropTypes from "prop-types";
import { titlePropType, appearancePropType, onDismissedPropType, childrenPropType } from "../../common";

/**
 * PropTypes for Toast component
 *
 * @property {string} title - Toast title text (required)
 * @property {string} [description] - Toast message/description text
 * @property {('success'|'error'|'warning'|'info')} [appearance] - Visual variant
 * @property {React.ReactNode} [icon] - Optional custom icon
 * @property {Array<{content: React.ReactNode, onClick?: Function}>} [actions] - Action buttons/links
 * @property {boolean} [isExpanded] - Whether content is expanded by default
 * @property {function} [onDismissed] - Callback fired when toast is dismissed
 */
export const toastPropTypes = {
  title: titlePropType.isRequired,
  description: PropTypes.string,
  appearance: appearancePropType,
  icon: PropTypes.node,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node,
      onClick: PropTypes.func,
    })
  ),
  isExpanded: PropTypes.bool,
  onDismissed: onDismissedPropType,
};

/**
 * PropTypes for ToastContainer component
 *
 * @property {React.ReactNode} [children] - Toast components to display
 * @property {boolean} [autoDismiss] - Enable auto-dismiss functionality
 * @property {function} [onDismissed] - Callback fired when any toast is dismissed
 * @property {boolean} [isExpanded] - Whether toasts should mount expanded
 */
export const toastContainerPropTypes = {
  children: childrenPropType,
  autoDismiss: PropTypes.bool,
  onDismissed: onDismissedPropType,
  isExpanded: PropTypes.bool,
};

/**
 * PropTypes for internal Toast child wrapper.
 */
export const toastChildWrapperPropTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  timerId: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  removeFirstToast: PropTypes.func,
  setTimerId: PropTypes.func,
  onDismissed: onDismissedPropType,
  autoDismiss: PropTypes.bool,
  index: PropTypes.number,
};
